import { SPEEDLABEL_WEB_API_BASE } from '../constants';

const { get } = require('../api/api');

export const getDesktopAppInstallLink = async () => await get(`${SPEEDLABEL_WEB_API_BASE}/api/public/applications/SPEEDsnip`, false);
